import { InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { Contract } from "./classes";

export const CONTRACT_PROVIDER_SERVICE = new InjectionToken<IContractProviderService>('CONTRACT_PROVIDER_SERVICE');

export interface IContractProviderService {
    contractId$: Observable<number>;
    contract$: Observable<Contract>;
}

export const CONTRACTS_PROVIDER_SERVICE = new InjectionToken<IContractsProviderService>('CONTRACTS_PROVIDER_SERVICE');

export interface IContractsProviderService {
    contracts$: Observable<Contract[]>;
}